import React from "react";

import { Box, Typography, IconButton, Chip } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";

import DataTable from "../../ui/Table";

const badgeColor = (name) => {
  const colors = {
    IT: "#dbeafe",
    HR: "#dcfce7",
    Finance: "#ede9fe",
    Admin: "#dbeafe",
    NW: "#fef3c7",
    SW: "#fce7f3"
  };

  return colors[name] || "#f1f5f9";
};

function DepartmentTable({
  departments,
  loading,
  onEdit,
  onDelete,
  onView,
  selectedIds = [],
  onSelectionChange
}) {
  const columns = [
    {
      key: "department_name",
      label: "Department Name",
      width: 350,

      render: (department) => (
        <Box display="flex" alignItems="center" gap={1.5}>
          <Chip
            label={department.department_name.substring(0, 3).toUpperCase()}
            size="small"
            sx={{ background: badgeColor(department.department_name), fontWeight: 600, fontSize: 12 }}
          />

          <Typography fontSize={14} fontWeight={600} color="text.primary">
            {department.department_name}
          </Typography>
        </Box>
      )
    },
    {
      key: "description",
      label: "Description",
      render: (department) => (
        <Typography fontSize={14} color="#475569">
          {department.description || "No description"}
        </Typography>
      )
    },
    {
      key: "actions",
      label: "Actions",
      width: 150,
      render: (department) => (
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <IconButton
            onClick={() => onView && onView(department)}
            sx={{ background: "#eff6ff", width: 32, height: 32 }}
          >
            <VisibilityIcon fontSize="small" sx={{ color: "#2563eb" }} />
          </IconButton>

          <IconButton
            onClick={() => onEdit(department)}
            sx={{ background: "#fff7ed", width: 32, height: 32 }}
          >
            <EditIcon fontSize="small" sx={{ color: "#f97316" }} />
          </IconButton>

          <IconButton
            onClick={() => onDelete(department)}
            sx={{ background: "#fef2f2", width: 32, height: 32 }}
          >
            <DeleteIcon fontSize="small" sx={{ color: "#ef4444" }} />
          </IconButton>
        </Box>
      )
    }
  ];

  return (
    <DataTable
      columns={columns}
      rows={departments}
      loading={loading}
      rowKey={(department) => department.department_id}
      selectable
      selectedIds={selectedIds}
      onSelectionChange={onSelectionChange}
      rowsPerPage={10}
      emptyState={{
        icon: ApartmentRoundedIcon,
        title: "No departments available",
        subtitle: "Create your first department so teams can be organized properly."
      }}
    />
  );
}

export default DepartmentTable;
